import { LegacyCard } from "@octopusdeploy/design-system-components";
import { WelcomeDialogProjectIcon } from "../WelcomeDialogProjectIcon";
import type { WelcomeDialogCardProps } from "./WelcomeDialogCardProps";
import { cardStyles } from "./styles";
export function ViewProjectsCard({ busy, onClick }: WelcomeDialogCardProps) {
    return (<LegacyCard link={!busy && (<a href="#" onClick={onClick} className={cardStyles.link}>
                        View projects
                    </a>)} logo={<div className={cardStyles.logo(!busy)}>
                    <WelcomeDialogProjectIcon />
                </div>} header={<div className={cardStyles.header}>View projects</div>} content={"Check out your existing Octopus projects."} className={cardStyles.card} contentClassName={cardStyles.content} leftAlign={true}/>);
}
